import styled from "@emotion/styled/macro";
import { BodyContentLayout } from "../../components/ui/ContentLayout";
import { useTranslation } from "react-i18next";
import bullet from "../../assets/images/bullet.svg";
import { Link, useLocation } from "react-router-dom";
import { ArrowBackIcon } from "@chakra-ui/icons";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background: ${({ theme }) => theme.colors.white};
`;
const Wrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 3em 0;
  }
  display: flex;
  flex-direction: column;
  padding-top: 2em;
  line-height: 1.5em;
`;

const Subtitle = styled.h2`
  padding-top: 2em;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: ${({ theme }) => theme.fontSizes.lg};
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 0.4em;
`;

const Subsubtitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.body};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
`;
const Text = styled.p`
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.primary};
`;
const Title = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  color: ${({ theme }) => theme.colors.primary};
  font-size: ${({ theme }) => theme.fontSizes.xl};
  margin-bottom: 2em;
`;
const Bullets = styled.ul`
  padding-left: 2em;
  list-style: outside url(${bullet});
  font-family: ${({ theme }) => theme.fonts.body};
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
  li {
    padding: 0.5em 0;
  }
`;

const BackLink = styled.div`
  display: flex;
  margin-bottom: 1em;
`;

const Privacy = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const enteredValues = location?.state;
  return (
    <Container>
      <BodyContentLayout>
        <Wrapper>
          {enteredValues && (
            <BackLink>
              <Link
                to={{
                  pathname: "/check",
                  state: enteredValues,
                }}
              >
                <ArrowBackIcon /> {t("common.backSearch")}
              </Link>
            </BackLink>
          )}
          <Title>{t("privacy.title")}</Title>
          <Text>{t("privacy.version")}</Text>
          <Text>{t("privacy.introduction")}</Text>
          <Subtitle>{t("privacy.subtitle1")}</Subtitle>
          <Subsubtitle>{t("privacy.subtitle1A")}</Subsubtitle>
          <Text>{t("privacy.text1A")}</Text>
          <Subtitle>{t("privacy.subtitle1B")}</Subtitle>
          <Text>{t("privacy.intro1B")}</Text>
          <Bullets>
            <li>{t("privacy.bulleta1B")}</li>
            <li>{t("privacy.bulletb1B")}</li>
          </Bullets>
          <Text>{t("privacy.text1B")}</Text>
          <Subtitle>{t("privacy.subtitle2")}</Subtitle>
          <Text>{t("privacy.intro2")}</Text>
          <Bullets>
            <li>{t("privacy.bulleta2")}</li>
            <li>{t("privacy.bulletb2")}</li>
            <li>{t("privacy.bulletc2")}</li>
            <li>{t("privacy.bulletd2")}</li>
          </Bullets>
          <Subtitle>{t("privacy.subtitle3")}</Subtitle>
          <Subsubtitle>{t("privacy.subtitle3A")}</Subsubtitle>
          <Text>{t("privacy.text3A")}</Text>
          <Bullets>
            <li>{t("privacy.bulleta3A")}</li>
            <li>{t("privacy.bulletb3A")}</li>
            <li>{t("privacy.bulletc3A")}</li>
          </Bullets>
        </Wrapper>
      </BodyContentLayout>
    </Container>
  );
};

export default Privacy;
